export default "__VITE_ASSET__$qRrhnid__"